<template lang="pug">
  .the-welcome: .inner(:class="showBinaryBG")
    .header
      h3.header-title.text-center.no-select(v-html="welcomeTitle")
      .header-message.extra-msg.no-select
        p.paragraph(v-if="$store.state.config.branded === 'anderida'" v-text="welcomeMSGAnderida")
        p.paragraph(v-else-if="$store.state.config.branded === 'ds'" v-text="welcomeMSGDS")
        p.paragraph(v-else-if="$store.state.config.branded === 'scapital'" v-text="welcomeMSGSCAPITAL")
        p.paragraph(v-else v-text="welcomeMSG")
    .body: .body-inner
      .img.anderida-special(v-if="this.$store.state.config.branded === 'anderida'")
      .img.ds-special(v-else-if="this.$store.state.config.branded === 'ds'")
      .img.scapital-special(v-else-if="this.$store.state.config.branded === 'scapital'")
      .img(v-else): TheBrain
    .footer: .footer-nav.text-center
      UiButton(
        class="extra-btn"
        :text="['anderida', 'ds', 'scapital'].indexOf($store.state.config.branded) > -1 ? 'Начать знакомство' : 'Активировать'"
        @ui-btn-click="$emit('welcome-click', true)"
      )
</template>

<script>
import TheBrain from '@/components/TheBrain'

export default {
  name: 'TheWelcome',
  // Components ----------------------------------------------------------------
  components: { TheBrain },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      welcomeMSG: 'Многофункциональная интеллектуальная система управления инвестициями',
      welcomeMSGAnderida: 'Почему именно Anderida Financial Group? Мы используем персональный подход к клиентам, помогая вам обучаться в процессе инвестирования вашего капитала или при управлении активами – и это происходит с тем уровнем погружения в детали, который подходит лично вам.',
      welcomeMSGDS: 'Почему именно DS Consulting? Мы используем персональный подход к клиентам, помогая вам обучаться в процессе инвестирования вашего капитала или при управлении активами – и это происходит с тем уровнем погружения в детали, который подходит лично вам.',
      welcomeMSGSCAPITAL: 'Почему именно Smirnova Capital? Мы используем персональный подход к клиентам, помогая вам обучаться в процессе инвестирования вашего капитала или при управлении активами – и это происходит с тем уровнем погружения в детали, который подходит лично вам.'
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Show binary bg
    showBinaryBG () {
      const branded = this.$store.state.config.branded
      return { binary: ['anderida', 'ds', 'scapital'].indexOf(branded) < 0 }
    },
    // Welcome title
    welcomeTitle () {
      const branded = this.$store.state.config.branded
      if (branded === 'anderida') return 'Клиентский портал Anderida Financial Group'
      if (branded === 'ds') return 'Клиентский портал DS Consulting'
      if (branded === 'scapital') return 'Клиентский портал Smirnova Capital'
      return 'CONOMY Terminal'
    }
  }
}
</script>
